import { render, staticRenderFns } from "./ResourceLanguages.vue?vue&type=template&id=5ebc4c00"
import script from "./ResourceLanguages.vue?vue&type=script&lang=js"
export * from "./ResourceLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports